import React from 'react';
import { NavLink } from 'react-router-dom';

const teamMembers = [
    {
        image: require('./../../images/our-team4/pic1.png'),
        membername: 'Hari Kuppuraj',
        position: 'President & CEO',
        content:'President and CEO of Trivik Builders, leads with a focus on quality and customer satisfaction.His vision drives the company’s success and growth.',
        
    },
    {
        image: require('./../../images/our-team4/pic2.png'),
        membername: 'Kumar Savitala',
        position: 'Project Leader',
        content:'Project Leader at Trivik Builders, manages projects with precision and care and ensures timely delivery and top-quality results for every client.',
    },
    {
        image: require('./../../images/our-team4/pic3.png'),
        membername: 'Sowmia Hari',
        position: 'Creative Director',
        content:'Creative Director at Trivik Builders, combines innovative design with strategic vision & transforms concepts into functional,that redefine every project.',
    }
]

class Team3 extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-white inner-page-padding">
                    <div className="container">
                        {/* TITLE START */}
                        <div className="section-head">
                            <div className="mt-separator-outer separator-left">
                                <div className="mt-separator">
                                    <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Our</span> Team</h2>
                                </div>
                            </div>
                        </div>
                        {/* TITLE END */}
                        {/* IMAGE Team START */}
                        <div className="section-content">
                            <div className="row">
                                {teamMembers.map((item, index) => (
                                    <div key={index} className="col-md-4 col-sm-6 col-xs-6 col-xs-100pc m-b30   ">
                                        <div className="our-team-1 hover-animation-1">
                                            <div className="profile-image scale-in-center"><img src={item.image} alt="" /></div>
                                            <div className="figcaption">
                                                <h4>{item.membername}</h4>
                                                <h5><strong>{item.position}</strong></h5>
                                                <p>{item.content}</p>
                                               
                                                <div className="icons">
                                                    <NavLink to={"#"} ><i className="fa fa-facebook" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-twitter" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-instagram" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-linkedin" /></NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                               
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Team3;